var exports = {
  "s": "CharacterCountAnnouncer.module__srOnly___QUdlTH",
};

module.exports = exports;
